/*
  Pick a Pearl, the join. Shared by the popup (wx-pearl.js) and the game page's own form
  (wx-pearl-game.js), so a person who arrives on /pages/pick-a-pearl from a shared link
  joins exactly the way a popup visitor does.

  1. POST /join to the pearl Worker: one row per email, returns the token. An email that
     has played before gets its old token back, so it sees its result, not a second pick.
  2. Subscribe to Klaviyo through the public client endpoint, the same call wx-optin.js
     makes (the welcome flow triggers on Added to List), with wx_form and wx_pearl_link,
     which the v4 "come play" email uses for anyone who joins and does not pick.
  3. Count it: polite-metrics (views, steps, submits), the Meta Lead, the CAPI Lead.

  Config comes from one element's data attributes, [data-wxp-cfg], written by the section.
  NO SECRETS HERE: company is the public site id, the Worker URL is public.
*/
(function () {
  'use strict';
  if (window.wxPearlCore) return;
  var el = document.querySelector('[data-wxp-cfg]');
  if (!el) return;
  var d = el.dataset;
  var cfg = {
    api: (d.api || '').replace(/\/$/, ''), company: d.company, list: d.list, form: d.form, lp: d.lp || 'pearl',
    game: d.game || '/pages/pick-a-pearl', collect: d.collect, capi: d.capi, client: d.client,
    turnstile: d.turnstile || '', country: (d.country || '').toUpperCase()
  };
  var K = 'https://a.klaviyo.com/client', REV = '2025-07-15';

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function anonId() {
    var a = get('wx_anon');
    if (!a) { a = 'wx-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10); set('wx_anon', a); }
    return a;
  }
  var source = (function () {
    try {
      var q = new URLSearchParams(location.search), out = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { var v = q.get(k); if (v) out[k] = String(v).slice(0, 60); });
      if (q.get('fbclid')) out.paid_click = 'meta';
      if (q.get('gclid')) out.paid_click = 'google';
      if (!out.utm_source && !out.paid_click) out.utm_source = document.referrer ? 'referral' : 'direct';
      return out;
    } catch (e) { return {}; }
  })();

  // Same counter, same test rules as wx-optin.js: our crawls and unpublished themes never count.
  function collect(event, props) {
    if (!cfg.collect) return;
    var body = Object.assign({
      event: event, form: cfg.form, lp: cfg.lp, visitor: anonId(), country: cfg.country, page: location.pathname,
      test: /[?&]wx_test=1/.test(location.search) || /HeadlessChrome/.test(navigator.userAgent) ||
        !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') || undefined
    }, source, props || {});
    try {
      fetch(cfg.collect, { method: 'POST', keepalive: true, mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .catch(function () {});
    } catch (e) {}
  }
  function cookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function lead(email) {
    var eid = 'wx-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: cfg.form, content_category: 'signup' }, { eventID: eid }); } catch (e) {}
    if (!cfg.capi || !cfg.client) return;
    try {
      var fbc = cookie('_fbc'), fbclid = (location.search.match(/[?&]fbclid=([^&#]+)/) || [])[1];
      if (!fbc && fbclid) fbc = 'fb.1.' + Date.now() + '.' + decodeURIComponent(fbclid);
      fetch(cfg.capi, { method: 'POST', keepalive: true, mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
        client: cfg.client, email: email, event_id: eid, fbp: cookie('_fbp') || undefined, fbc: fbc || undefined,
        url: location.href.split('#')[0], form: cfg.form, lp: cfg.lp }) }).catch(function () {});
    } catch (e) {}
  }

  function subscribe(attrs, sms) {
    var profile = { type: 'profile', attributes: Object.assign({ anonymous_id: anonId() }, attrs) };
    profile.attributes.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (attrs.phone_number && sms) profile.attributes.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    return fetch(K + '/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: REV },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: profile } },
        relationships: { list: { data: { type: 'list', id: cfg.list } } } } })
    }).then(function (r) {
      if (r.status === 202) return true;
      return r.json().catch(function () { return {}; }).then(function (j) {
        throw new Error((j.errors && j.errors[0] && (j.errors[0].detail || j.errors[0].title)) || 'Klaviyo ' + r.status);
      });
    });
  }

  // Turnstile, invisible, only when a site key is set on the section.
  var ts = null;
  function human() {
    if (!cfg.turnstile) return Promise.resolve('');
    if (!ts) ts = new Promise(function (ok) {
      window.wxpTs = function () {
        var box = document.createElement('div'); box.style.cssText = 'position:fixed;left:-9999px;top:0';
        document.body.appendChild(box);
        var id = turnstile.render(box, { sitekey: cfg.turnstile, size: 'invisible', execution: 'execute',
          callback: function (t) { ok({ id: id, t: t }); }, 'error-callback': function () { ok({ id: id, t: '' }); } });
        turnstile.execute(box);
      };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=wxpTs'; s.async = true;
      document.head.appendChild(s);
    });
    return ts.then(function (r) { ts = null; return r.t; });
  }

  function link(token) { return location.origin + cfg.game + '?t=' + token; }

  // The whole join. Resolves to the token; rejects with a message a person can read.
  function join(o) {
    var email = String(o.email || '').trim();
    return human().then(function (tsToken) {
      return fetch(cfg.api + '/join', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, first_name: o.first_name, from: o.from || '', turnstile: tsToken }) });
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status === 403 ? 'We could not check you are not a robot. Refresh and try again.' : 'That did not go through. Try again in a moment.');
      return r.json();
    }).then(function (j) {
      set('wx_pearl_t', j.token); set('wx_email', email); set('wx_optin_joined', String(Date.now()));
      var props = Object.assign({ wx_source: 'wx-pearl', wx_lp: cfg.lp, wx_form: cfg.form, wx_pearl_link: link(j.token) },
        source.utm_source ? { wx_utm_source: source.utm_source } : {}, source.utm_campaign ? { wx_utm_campaign: source.utm_campaign } : {},
        source.paid_click ? { wx_paid_click: source.paid_click } : {});
      // Someone who has played before is already on the list; no second subscribe, no second Lead.
      if (j.picked) return j;
      return subscribe({ email: email, first_name: o.first_name || undefined, properties: props }).then(function () {
        collect('submitted', { step: 1 }); lead(email);
        return j;
      });
    });
  }

  function addPhone(email, phone, sms) {
    return subscribe({ email: email, phone_number: phone }, sms).then(function () { collect('submitted', { step: 2 }); });
  }

  window.wxPearlCore = { cfg: cfg, join: join, addPhone: addPhone, collect: collect, get: get, set: set, link: link };
})();
